"use client";

import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Skeleton,
  Typography,
} from "@mui/material";
import { FetchCampaignsV2Response } from "@/api/interfaces/responses/campaigns";
import { campaignAssigneesQueryOptions } from "@/queryOptions/campaigns";
import { ModalContext } from "@/shared/Modal/ModalContextProvider";

interface CampaignDetailsModalProps {
  campaign: FetchCampaignsV2Response;
}

export default function CampaignDetailsModal({
  campaign,
}: CampaignDetailsModalProps) {
  const { open, setOpen } = useContext(ModalContext);
  const { data: assignees, isLoading: assigneesLoading } = useQuery(
    campaignAssigneesQueryOptions(campaign.id.toString()),
  );

  const onClose = () => {
    setOpen?.(false);
  };

  const assigneesElement = assigneesLoading ? (
    <Skeleton variant="rectangular" width="80%" height={40} />
  ) : assignees?.users?.length ? (
    <div className="flex flex-col my-1">
      {assignees.users.map((assignee, index) => (
        <Typography key={assignee.id + index} variant="body2">
          {assignee.email}
        </Typography>
      ))}
    </div>
  ) : (
    <Typography variant="body2">No assignees found</Typography>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className="text-center font-bold">
        {campaign.name}
      </DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-5 mt-1">
          <div className="flex flex-col">
            <Typography className="font-semibold">Search Terms</Typography>
            <div className="flex flex-wrap gap-2 my-1">
              {campaign.data.searchTerms.map((term, index) => (
                <Chip
                  key={`${term}-${index}`}
                  label={term}
                  variant="outlined"
                />
              ))}
            </div>
          </div>
          <div className="flex flex-col">
            <Typography className="font-semibold">Assignees</Typography>
            {assigneesElement}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
